import { PhotoAppOrderEntity } from './photoAppOrderEntity';
import {
  PhotoOrderEntity,
} from './photoOrderEntity';
import { ChildId } from './valueObjects/childId';
import { CreateDatetime } from './valueObjects/createDatetime';
import { DeliveryStatus } from './valueObjects/deliveryStatus';
import { ExpirationDate } from './valueObjects/expirationDate';
import { LastModifiedDatetime } from './valueObjects/lastModifiedDatetime';
import { MemberId } from './valueObjects/memberId';
import { NumberOfItems } from './valueObjects/numberOfItems';
import { ParentId } from './valueObjects/parentId';
import { PaymentStatus } from './valueObjects/paymentStatus';
import { PaymentType } from './valueObjects/paymentType';
import { PhotoId } from './valueObjects/photoId';
import { PhotoItemId } from './valueObjects/photoItemId';
import { PhotoItemName } from './valueObjects/photoItemName';
import { Price } from './valueObjects/price';
import { S3Filename } from './valueObjects/s3Filename';
import { SalesGroupId } from './valueObjects/salesGroupId';
import { SalesGroupName } from './valueObjects/salesGroupName';

import type {
  PhotoOrderPropsPub,
  PhotoOrderPropsPvt,
} from './photoOrderEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { PhotoOrderJsonPub, PhotoOrderJsonPvt } from '@/types/domain/photo/entities/photoOrderEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class PhotoOrderFactory extends FactoryPub<
  PhotoOrderEntity,
  PhotoOrderPropsPvt,
  PhotoOrderJsonPvt,
  PhotoOrderPropsPub,
  PhotoOrderJsonPub
> {
  comparePub = (
    a: EntityDataPubType<PhotoOrderJsonPvt, PhotoOrderJsonPub>,
    b: EntityDataPubType<PhotoOrderJsonPvt, PhotoOrderJsonPub>,
  ) => {
    const da = new Date(a.data.lastModifiedDatetime);
    const db = new Date(b.data.lastModifiedDatetime);
    return da < db ? 1 : -1;
  };

  create(
    props: PhotoOrderPropsPvt,
    propsPub: EntityPubNotNullType<PhotoOrderPropsPub>,
  ): PhotoOrderEntity {
    return new PhotoOrderEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<PhotoOrderJsonPvt, PhotoOrderJsonPub>,
  ): PhotoOrderEntity {
    return this.create({
      salesGroupId: SalesGroupId.create(props.data.salesGroupId),
      salesGroupName: SalesGroupName.create(props.data.salesGroupName),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      deliveryStatus: DeliveryStatus.create(props.data.deliveryStatus),
      paymentStatus: PaymentStatus.create(props.data.paymentStatus),
      paymentType: PaymentType.create(props.data.paymentType),
      price: Price.create(props.data.price),
      photos: props.data.photos.map((v) => new PhotoAppOrderEntity({
        photoId: PhotoId.create(v.photoId),
        s3Filename: v.s3Filename ? S3Filename.create(v.s3Filename) : undefined,
        photoItemId: PhotoItemId.create(v.photoItemId),
        photoItemName: PhotoItemName.create(v.photoItemName),
        price: Price.create(v.price),
        numberOfItems: NumberOfItems.create(v.numberOfItems),
      }, null)),
      expirationDate: ExpirationDate.create(new Date(props.data.expirationDate)),
      createDatetime: CreateDatetime.create(new Date(props.data.createDatetime)),
      createMemberId: MemberId.create(props.data.createMemberId),
      lastModifiedDatetime: LastModifiedDatetime.create(new Date(props.data.lastModifiedDatetime)),
      lastModifiedMemberId: MemberId.create(props.data.lastModifiedMemberId),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},

    });
  }
}
